export enum ConfigurationFunction {
    INTERNET_LTE = "INTERNET_LTE",
    INTERNET_5G_NR = "INTERNET_5G_NR",
    INTERNET_EWAN = "INTERNET_EWAN",
    INTERNET_EWAN_MULTIPLE_SERVICE = "INTERNET_EWAN_MULTIPLE_SERVICE",
    INTERNET_WIRELESS_CLIENT = "INTERNET_WIRELESS_CLIENT",
    WIFI_24G = "WIFI_24G",
    WIFI_5G = "WIFI_5G",
    SPEED_TEST_SERVER = "SPEED_TEST_SERVER",
    CBSD = "CBSD",
    BECENTRAL = "BECENTRAL",
    SERIAL_1 = "SERIAL_1",
    SERIAL_2 = "SERIAL_2",
    RGOOSE = "RGOOSE",
    PTP = "PTP",
    DEVICE_MANAGMENT = "DEVICE_MANAGMENT",
    ACCESS_CONTROL = "ACCESS_CONTROL",
    USER_MANAGEMENT = "USER_MANAGEMENT"
};

export enum OldConfigurationFunction {
    INTERNET_LTE = "internet_lte",
    INTERNET_5G_NR = "internet_5g_nr",
    BECENTRAL = "becentral",
    CBSD = "cbsd",
    SERIAL_1 = "serial_1",
    SERIAL_2 = "serial_2",
    RGOOSE = "rgoose",
    PTP = "ptp",
    DEVICE_MANAGMENT = "device_management",
    ACCESS_CONTROL = "access_control",
    USER_MANAGEMENT = "user_management",
    SPEED_TEST_SERVER = "speed_test_server"
};

export enum ConfigurationFunctionOption {
    DEFAULT = ""
};

export enum ConfigurationNode {
    WIFI_24G = 'WLan',
    WIFI_5G = 'WLan11ac',
    SPEED_TEST_SERVER = 'AutoGenerate',
    CBSD = 'CBSD',
    BECENTRAL = 'MqttConf',
    SERIAL_1 = 'SerialAPP',
    SERIAL_2 = 'SerialAPP2',
    RGOOSE = 'Rgoose',
    PTP = 'PTP',
    DEVICE_MANAGMENT = 'DEVICE_MANAGMENT',
    LAN = 'Lan',
    WEB_SERVER = 'Webserver',
    ACCESS_CONTROL = "ACL",
    USER_MANAGEMENT = 'Account',
    INTERNET_LTE = 'INTERNET_LTE',
    INTERNET_5G_NR = 'INTERNET_5G_NR',
    INTERNET_EWAN = 'INTERNET_EWAN',
    INTERNET_EWAN_MULTIPLE_SERVICE = 'INTERNET_EWAN_MULTIPLE_SERVICE',
    INTERNET_WIRELESS_CLIENT = 'INTERNET_WIRELESS_CLIENT',
    WAN = 'Wan',
    WAN_EXT = 'WanExt',
    USAGE = 'Usage',
    DHCP6S = 'Dhcp6s'
};

export type ConfigurationFunctionNameMap = {
    [key in ConfigurationFunction]: string;
};

export type ConfigurationFunctionNodeMap = {
    [key in ConfigurationFunction]: ConfigurationNode;
};

export interface FunctionOption {
    name: string;
    value: string;
};

export interface ConfigurationFunctionProfile {
    configFunction: ConfigurationFunction | ConfigurationFunctionOption;
    profile: any;
};

export interface FunctionProfile {
    [ConfigurationNode.WAN]?: any;
    [ConfigurationNode.USAGE]?: any;
    [ConfigurationNode.CBSD]?: any;
    [ConfigurationNode.SERIAL_1]?: any;
    [ConfigurationNode.SERIAL_2]?: any;
    [ConfigurationNode.PTP]?: any;
    [ConfigurationNode.RGOOSE]?: any;
    [ConfigurationNode.LAN]?: any;
    [ConfigurationNode.ACCESS_CONTROL]?: any;
    [ConfigurationNode.SPEED_TEST_SERVER]?: any;
};
